import { flow, Runtime } from "fp";

import * as Data from "~/Data";
import { Company } from "~/Company";
import * as Document from "~/Document";
import { Request } from "~/Request";

export namespace Get {
  /** [API Documentation](http://equipmentshare.pages.internal.equipmentshare.com/equipmentshare-api/develop/index.html?highlight=doc#get--companies-(int-company_id)-docs) */
  export const request = ({
    company,
  }: Company): Data.Cache.Request<Document.Document> =>
    flow(
      Request.fromConfig({
        endpoint: `/elogs/companies/${company.id}/docs`,
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(Document.Response.runtime())),
      Request.onSuccess(
        Data.Cache.fromList(
          flow(Document.Response.decode, (document) => [document.id, document])
        )
      )
    );
}
